module.exports = __webpack_public_path__ + "static/pentadrone-349598c7783f764996a38074fac7d997.jpeg";